import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import {Radio, RadioGroup, FormControlLabel,Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";

const DownloadTypeModal = ({downloadTypeModal, setDownloadTypeModal,selectType,setSelectType, downloadForms, selectedRows}) => {

  const customForms = selectedRows?.filter((form) => form?.form_type === "custom" || form?.generated_form?.form_type);

  const useStyles = makeStyles({
    smallRadio: {
        "& svg": {
            width: 20,
            height: 20
        },
        "& svg > circle": {
            width: 12,
            height: 12
        }
    }});

  const classes = useStyles();

  const handleSubmit = () =>{
    downloadForms();
    setDownloadTypeModal(false)
  }

  const handleCancel = () => {
    setSelectType(null)
    setDownloadTypeModal(false);
  }

  return (
    <Dialog
      open={downloadTypeModal}
      onClose={() => setDownloadTypeModal(false)}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <Box sx={{ml:4,mr:4,mt:4}}>
      <Typography style={{ fontWeight: 'bold' }}>{`Download (${(customForms?.length || 0)}  custom form(s))`}</Typography>
        <Typography variant="caption" style={{ fontStyle: '#808080'}}> Select your preferred format for downloading custom forms</Typography>

        <RadioGroup name="download-type" value={selectType} onChange={(e)=> setSelectType(e.target.value)}>
            <FormControlLabel value="docx" control={<Radio className={classes.smallRadio} />} label= "DOC" />
            {/* <FormControlLabel value="msg" control={<Radio className={classes.smallRadio} />} label= "MSG"/> */}
            <FormControlLabel value="eml" control={<Radio className={classes.smallRadio} />} label= "EML"/>
        </RadioGroup>
      </Box>

      <Typography variant="caption" style={{ fontStyle: 'italic'}} sx={{ml:4,mr:4,mt:2}}>Note: This selection is specific to custom forms only, standard forms will be downloaded as PDFs</Typography>
  
      <Box sx={{ display: "flex", justifyContent: "flex-end", ml:4,mr:4,mb:4}}>
        <Button onClick={handleCancel} type="button" variant="outlined" style={{ color: '#000',marginRight : "2%" }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" style={{ backgroundColor: '#010160', color: 'white' }} disabled={!selectType}>
          Download
        </Button>
      </Box>
    </Dialog>
  );
}

export default DownloadTypeModal;
